var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#CCC",
      "fill-rule": "evenodd",
      "d": "M19.83 10.88c.11-.25.17-.52.17-.8V9c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 0 0-.88-1.22L12 0 5.59 6.41C5.21 6.79 5 7.3 5 7.83v7.84A2.34 2.34 0 0 0 7.34 18h8.11c.7 0 1.36-.37 1.72-.97zM0 18h2c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H0z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }